import { render, staticRenderFns } from "./TermosDeAceiteBP.vue?vue&type=template&id=2003c912&scoped=true"
import script from "./TermosDeAceiteBP.vue?vue&type=script&lang=ts"
export * from "./TermosDeAceiteBP.vue?vue&type=script&lang=ts"
import style0 from "./TermosDeAceiteBP.vue?vue&type=style&index=0&id=2003c912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2003c912",
  null
  
)

export default component.exports